<template>
  <div>
    <banner img-path="diagnostic.jpg" banner-text="Diagnostic Products"/>
    <catalogue-section v-for="(catalogue, company, index) in catalogues" :key="index" :catalogue-sections="catalogue" :catalogue-heading="company" :catalogue-index="index"/>
  </div>
</template>

<script>
import CatalogueSection from '../components/CatalogueSection.vue'
import banner from '@/components/Banner.vue'

export default {
  components: { CatalogueSection, banner},
  // eslint-disable-next-line
    name: 'Diagnostic',
    data(){
        return{
            catalogues : require("../assets/diagnostic-products.json"),
        }
    },
}
</script>